import DeliverySummaries from './DeliverySummaries';

export default DeliverySummaries;
